import './App.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Footer from "./components/Footer.js";

import React, { useEffect, useState, useCallback } from "react";
import { BrowserRouter as Router, Route, Routes, Link, useLocation, useNavigate } from "react-router-dom";
import { CartProvider } from './CartContext';
import Home from "./pages/Home";
import About from "./pages/About";
import Guide from "./pages/Guide";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Categories from "./pages/Categories";
import Shop from "./pages/Shop";
import LogIn from "./pages/Log-In.js";
import SignUp from "./pages/Sign-Up.js";
import Account from "./pages/Account.js";
import TOS from "./pages/TOS.js";
import PrivacyPolicy from "./pages/PrivacyPolicy.js";
import NotFound from './pages/404';
import VerifyEmail from './pages/VerifyEmail.js';
import ForgotPassword from './pages/ForgotPassword.js';
import ResetPassword from './pages/ResetPassword.js';
import CheckoutSuccess from './pages/CheckoutSuccess';
import ReviewOrder from './pages/ReviewOrder';
import { API_BASE_URL } from './config';

import Cart from "./pages/Cart";
import EnterShipping from './pages/EnterShipping';
import ProductDetail from "./components/ProductDetail";
import axios from "axios";
import sideLogo from "./images/Side.png";
import mainLogo from "./images/Main.png";
import placeholderImage from "./images/placeholderImage.jpg";

function matchSearch(query, target) {
  const normalizedQuery = query.toLowerCase();
  const normalizedTarget = target.toLowerCase();

  let queryIndex = 0;

  for (let char of normalizedTarget) {
    if (char === normalizedQuery[queryIndex]) {
      queryIndex++;
    }
    if (queryIndex === normalizedQuery.length && normalizedTarget.includes(normalizedQuery)) {
      return true;
    }
  }

  return false;
}

function ScrollToTopOnRouteChange() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  return null;
}

function App() {
  const navigate = useNavigate();
  const [shopNavIsHovered, setShopNavIsHovered] = useState(false);
  const [products, setProducts] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [isVerified, setIsVerified] = useState(null);
  const [navbarToggled, setNavbarToggled] = useState(false);

  // Capture the referring URL once per browser session so ProductDetail can log it with each visit
  useEffect(() => {
    if (!sessionStorage.getItem('referral')) {
      sessionStorage.setItem('referral', document.referrer || 'direct');
    }
  }, []);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/products`)
      .then((response) => {
        setProducts(response.data)
      })
      .catch((error) => {
        console.error("Error fetching products:", error)
        setProducts("Error while fetching products. Please reload the page or contact customer service for support.")
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/api/auth/verify-token`, { withCredentials: true })
      .then((res) => {
        setIsVerified(true);
      })
      .catch((err) => {
        console.error("Token invalid or error:", err.response?.data || err.message);
        setIsVerified(false);
      });
  }, []);

  const handleProductCatalogging = useCallback(() => {
    if (!products) return;

    const crystalCategorySet = new Set();
    const botanicalCategorySet = new Set();
    const productVariationsMap = new Map();
    for (let product of products) {
      const splitName = product.name.split("(");
      if (product?.["category"].toLowerCase() == "botanicals") {
        botanicalCategorySet.add(product?.["subcategory"])

        if (splitName.length > 1) {
          if (productVariationsMap.has(splitName[0])) {
            const updatedArray = productVariationsMap.get(splitName[0]);
            updatedArray.push(splitName?.[1]?.replace(")", ""))

            productVariationsMap.set(splitName[0], updatedArray)
          } else {
            const newArray = Array(splitName?.[1]?.replace(")", ""))
            productVariationsMap.set(splitName[0], newArray)
          }
        }
      } else if (product?.["category"].toLowerCase() == "crystals") {
        crystalCategorySet.add(product?.["subcategory"])

        if (splitName.length > 1) {
          if (productVariationsMap.has(splitName[0])) {
            const updatedArray = productVariationsMap.get(splitName[0]);
            updatedArray.push(splitName?.[1]?.replace(")", ""))

            productVariationsMap.set(splitName[0], updatedArray)
          } else {
            const newArray = Array(splitName?.[1]?.replace(")", ""))
            productVariationsMap.set(splitName[0], newArray)
          }
        }
      } else {
        continue;
      };
    }
    sessionStorage.setItem("variations", JSON.stringify(Array.from(productVariationsMap)))
    sessionStorage.setItem("crystalCategories", JSON.stringify(Array.from(crystalCategorySet)));
    sessionStorage.setItem("botanicalCategories", JSON.stringify(Array.from(botanicalCategorySet)));
  }, [products])

  useEffect(() => {
    handleProductCatalogging();
  }, [handleProductCatalogging])

  const searchedItems = products
    .filter(productInFilter => matchSearch(searchInput, productInFilter.name)).map((product, i) => {
      if (i > 4) return;
      if (i == 4) return (<Link className="search-suggestion-more">View More</Link>)
      const splitName = product.name.split("(");
      const productImage = React.createElement("div", { className: "search-suggestion-item-image", style: { backgroundImage: `url(${product?.imageURL?.[0]?.includes('/upload/') ? product.imageURL[0].replace("/upload/", '/upload/c_thumb,w_240/') : placeholderImage})` } })
      return (
        <Link to={`/shop/${encodeURIComponent(product.name)}`} className="search-suggestion-item">{productImage}<span><p>{splitName[0]}</p>{splitName.length > 1 ? (<p>{splitName[1].replace(")", "")}</p>) : ""}</span></Link>
      );
    })

  return (
    <CartProvider>
      <div className="root-div">
        <section id="mainMenuDragdown" style={{ transform: navbarToggled ? "translateY(0%)" : "translateY(-200%)", opacity: navbarToggled ? 1 : 0 }}>
          <button id="mainMenuDragdownExit" onClick={() => { setNavbarToggled(!navbarToggled) }}><i className="bi bi-x-lg"></i></button>
          <ul>
            <li onClick={() => { setNavbarToggled(!navbarToggled) }}><Link to="/">Home</Link></li>
            <li onClick={() => { setNavbarToggled(!navbarToggled) }}><Link to="/about">About</Link></li>
            {/* <li><Link to="/guide">Guide</Link></li> */}
            <li onClick={() => { setNavbarToggled(!navbarToggled) }}><Link to="/faq">FAQ</Link></li>
            <li onClick={() => { setNavbarToggled(!navbarToggled) }}><Link to="/contact">Contact</Link></li>
            <li onClick={() => { setNavbarToggled(!navbarToggled) }}>
              <Link to="/categories" >Shop</Link>
            </li>
            <li>
              <div className="mobile-menu-settings">
                <li onClick={() => { setNavbarToggled(!navbarToggled) }}><Link to={isVerified ? "/account" : "/log-in"}><i className="bi bi-person"></i>{isVerified}</Link></li>
                <li onClick={() => { setNavbarToggled(!navbarToggled) }}><Link to="/cart"><i className="bi bi-cart"></i></Link></li>
              </div>
            </li>
          </ul>
        </section>
        <nav id="mainNav">
          <img id="mainLogo" src={sideLogo}></img>
          <img id="mainLogoMobile" src={mainLogo}></img>
          <ul id="mainUl">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            {/* <li><Link to="/guide">Guide</Link></li> */}
            <li><Link to="/faq">FAQ</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li onMouseEnter={() => { setShopNavIsHovered(true) }} onMouseLeave={() => { setShopNavIsHovered(false) }}>
              <Link to="/categories" style={{ position: "relative", paddingRight: "1.5rem" }}>Shop
              </Link>
            </li>
          </ul>
          <ul id="mainOptions">
            <div id="mainSearch">
              <input placeholder='Search' value={searchInput} onChange={(e) => { setSearchInput(e.currentTarget.value) }} onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  const tempSearch = searchInput;
                  setSearchInput('');

                  navigate(`/all${searchInput == "" ? "" : `?search=${encodeURIComponent(tempSearch)}`}`);
                }

              }}></input>
              <Link to={`/all${searchInput == "" ? "" : `?search=${encodeURIComponent(searchInput)}`}`} onClick={()=>{setSearchInput('')}}><i className="bi bi-search"></i></Link>
              <div className="search-suggestions-container">
                {searchInput
                  ?
                  products
                    .filter(productInFilter => matchSearch(searchInput, productInFilter.name)).map((product, i) => {
                      if (i > 4) return;
                      if (i == 4) return (<Link className="search-suggestion-more" to={`/all?search=${encodeURIComponent(searchInput)}`} onClick={()=>{setSearchInput("")}}>View More</Link>)
                      const splitName = product.name.split("(");
                      const productImage = React.createElement("div", { className: "search-suggestion-item-image", style: { backgroundImage: `url(${product?.imageURL?.[0]?.includes('/upload/') ? product.imageURL[0].replace("/upload/", '/upload/c_thumb,w_240/') : placeholderImage})` } })
                      return (
                        <Link to={`/product/${encodeURIComponent(product.name)}`} onClick={() => { setSearchInput('') }} className="search-suggestion-item">{productImage}<span><p>{splitName[0]}</p>{splitName.length > 1 ? (<p>{splitName[1].replace(")", "")}</p>) : ""}</span></Link>
                      );
                    }) : ""}
                {searchInput && !searchedItems.length ? (<div className="search-no-items">No items found!</div>) : ""}

              </div>
            </div>
            <li className="phone-display"><Link to={isVerified ? "/account" : "/log-in"}><i className="bi bi-person"></i>{isVerified}</Link></li>
            <li className="phone-display"><Link to="/cart"><i className="bi bi-cart"></i></Link></li>
            <li><button id="mainMenuButton" type="button" onClick={() => { setNavbarToggled(!navbarToggled) }}><i className="bi bi-list"></i></button></li>
          </ul>
        </nav>

        <section id="expandedShopNavMenu" style={{ display: `${shopNavIsHovered ? "block" : "none"}`, opacity: `${shopNavIsHovered ? "1" : "0"}` }}>
          <article>
            <div></div>
          </article>
        </section>
        <ScrollToTopOnRouteChange />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          {/* <Route path="/guide" element={<Guide />} /> */}
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/all" element={<Shop />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/botanicals" element={<Shop type="botanicals" />} />
          <Route path="/crystals" element={<Shop type="crystals" />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          {/* <Route path="/shop/:name" element={<ProductDetail />} /> */}
          <Route path="/cart" element={<Cart />} />
          <Route path="/enter-shipping" element={<EnterShipping />} />
          <Route path="/log-in" element={<LogIn />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/account" element={<Account />} />
          <Route path="/terms-of-service" element={<TOS />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/checkout-success" element={<CheckoutSuccess />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/review/:orderId" element={<ReviewOrder />} />
          <Route path="*" element={<NotFound />} />

        </Routes>
        <Footer />
      </div>
    </CartProvider>
  );
}

export default App;